import { History, Loader2, Clock, CheckCircle2, XCircle } from "lucide-react";

/**
 * Vermittler payout history list. Shows pending / paid / credited / rejected
 * payout requests with admin notes and dates.
 * Extracted from VermittlerDashboardPage.
 */
const STATUS_META = {
    pending: { label: "In Bearbeitung", color: "text-amber-700 bg-amber-100 border-amber-300", Icon: Clock },
    paid: { label: "Ausgezahlt", color: "text-blue-700 bg-blue-100 border-blue-300", Icon: CheckCircle2 },
    credited: { label: "Verrechnet", color: "text-green-700 bg-green-100 border-green-300", Icon: CheckCircle2 },
    rejected: { label: "Abgelehnt", color: "text-red-700 bg-red-100 border-red-300", Icon: XCircle },
};
const METHOD_LABEL = { bank: "Bank-Überweisung", paypal: "PayPal", credit_account: "Verrechnung" };

export default function PayoutHistory({ payouts, loading }) {
    return (
        <div className="bg-white border border-gray-200 rounded-sm" data-testid="payout-history">
            <div className="px-6 py-4 border-b border-gray-200 flex items-center gap-2">
                <History className="w-5 h-5 text-[#FFCC00]" />
                <h2 className="font-display font-bold text-lg">Auszahlungs-Historie</h2>
            </div>
            {loading ? (
                <div className="p-8 text-center text-gray-400"><Loader2 className="w-5 h-5 animate-spin mx-auto" /></div>
            ) : payouts.length === 0 ? (
                <div className="p-8 text-center text-gray-500 text-sm" data-testid="payouts-empty">
                    Noch keine Auszahlungsanfragen gestellt.
                </div>
            ) : (
                <ul className="divide-y divide-gray-100">
                    {payouts.map((p) => {
                        const meta = STATUS_META[p.status] || STATUS_META.pending;
                        const Icon = meta.Icon;
                        return (
                            <li key={p.id} className="px-6 py-3 flex items-start gap-3" data-testid={`payout-row-${p.id}`}>
                                <span className={`inline-flex items-center justify-center w-8 h-8 rounded-sm border ${meta.color}`}>
                                    <Icon className="w-4 h-4" />
                                </span>
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2 flex-wrap">
                                        <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-sm border ${meta.color}`}>
                                            {meta.label}
                                        </span>
                                        <span className="text-xs text-gray-500">{METHOD_LABEL[p.method] || p.method}</span>
                                    </div>
                                    {p.note && <div className="text-xs text-gray-700 mt-1 italic">„{p.note}"</div>}
                                    {p.decision_note && (
                                        <div className="text-xs text-gray-600 mt-1" data-testid={`payout-decision-note-${p.id}`}>
                                            <strong>Admin-Notiz:</strong> {p.decision_note}
                                        </div>
                                    )}
                                    <div className="text-[10px] text-gray-400 mt-1 font-mono-num">
                                        Beantragt: {new Date(p.created_at).toLocaleString("de-DE")}
                                        {p.decided_at && ` · Bearbeitet: ${new Date(p.decided_at).toLocaleString("de-DE")}`}
                                    </div>
                                </div>
                                <div className="text-right shrink-0">
                                    <div className="text-lg font-black font-mono-num text-[#111827]">{p.points}</div>
                                    <div className="text-[10px] uppercase tracking-wider text-gray-400">Punkte</div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
}
